import { Box, Group } from '@mantine/core';
import { MobileAccountBalance } from './account/MobileAccountBalance';
import { FreeBetsInfo } from './FreeBetsInfo';
import { SettingsButton } from './settings/SettingsButton';

export const MobileHeader = () => {
  return (
    <Box
      bg="dark.7"
      component="header"
      data-test-id="mobile-header"
      h={64}
      hiddenFrom="lg"
      left={0}
      pos="fixed"
      px={{
        base: 8,
        md: 16,
      }}
      right={0}
      style={{ zIndex: 200 }}
      top={0}
      w="100%"
    >
      <Group gap="sm" h="100%">
        <SettingsButton />
        <Group flex={1} justify="space-between">
          <FreeBetsInfo />
          <MobileAccountBalance />
        </Group>
      </Group>
    </Box>
  );
};
